import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { QUERY_KEYS } from '@/query/queryKeys';
import Notify from '@/components/Notification';
import { fundraisingService } from '../../services/fundraisingService';

export const useBorrowerConfirmFundraising = fundraisingId => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async payload => {
      const response = await fundraisingService.borrowerConfirmFundraising(payload);
      const { status, data } = response;

      if (status === 200) {
        fundraisingId &&
          queryClient.setQueryData(
            [QUERY_KEYS.fundraising.status_by_id, fundraisingId],
            () => data,
          );
        Notify.success({ text: t('fundraising:shared.fundraising_goal_confirmed') });
        return data;
      }

      return null;
    },
  });
};
